import { render, staticRenderFns } from "./ObjectProperties.vue?vue&type=template&id=639af306&scoped=true"
import script from "./ObjectProperties.vue?vue&type=script&lang=js"
export * from "./ObjectProperties.vue?vue&type=script&lang=js"
import style0 from "./ObjectProperties.vue?vue&type=style&index=0&id=639af306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639af306",
  null
  
)

export default component.exports